<template>
  <div class="day-trip-detail">
    <!-- 日行程内容-->
    <div v-for="(item,index) in day_trip"
         :key="index">
      <div class="day-trip-item">
        <!-- 迹点名称： -->
        <div class=""
             style="display:flex">
          <el-image style="width:80px"
                    :src="item.traver_cover"></el-image>
          <div style="margin-left:10px">
            <div>{{item.traver_title}}

            </div>
            <!-- 营业时间： -->
            <div>营业时间：{{item.open_time}}</div>
            <div>营业日期：{{item.open_value}}</div>
          </div>
        </div>

        <!-- 介绍 -->
        <div class=""
             v-html="item.traver_info"></div>
        <!-- 关联内容 -->
        <div class="">指南：</div>
        <!-- 周边推荐 -->
        <div class="">周边推荐：</div>
        <!-- 游玩导览 -->
        <div class="">游玩推荐：</div>
        <!-- 打车信息 -->
        <!-- <div>
          打车搜索：{{item.take_taxi}} <span style="float:right">{{item.traffic_id}}</span>
        </div> -->
        <!-- traver_id -->
        <div style="width:100%;text-align:right">ID:{{item.id}}</div>
      </div>
      <!-- 打车说明 -->

      <!-- 显示选择的交通方案 -->
      <div>
        <draggable v-model="item.TrafficPlan"
                   animation="1000"
                   filter=".unmover"
                   @end="dragFinish">
          <!-- <div>如何前往：{{day_trip[index+1].traver_title}}</div> -->
          <div class="day-trip-item"
               style="background-color:lightgrey"
               v-for="item,index in item.TrafficPlan"
               :key="index">

            <!-- 前往方式方式标签 -->
            <div>方案名称：{{item.traffic_plan_name}}
              <!-- 交通方案id -->
              <span style="float:right">Tid:{{item.traffic_plan_id}}</span>
            </div>
            <div>前往方式：
              <el-tag size="mini"
                      v-if="item.traffic_type=='walking'">徒步</el-tag>
              <el-tag size="mini"
                      v-else-if="item.traffic_type=='bicycling'">骑行</el-tag>
              <el-tag size="mini"
                      v-else-if="item.traffic_type=='driving'">驾车
              </el-tag>
              <el-tag size="mini"
                      v-else-if="item.traffic_type=='transit'">公共交通
              </el-tag>
            </div>
            <!-- 交通说明说明该 -->
            <div v-html="item.traffic_introduce"></div>
          </div>
        </draggable>
      </div>

      <!-- 添加交通的按钮 -->
      <div>
        <button-auto @clickBtn="addTrafficePoint(item)"
                     buttonName="添加/选择交通"></button-auto>

      </div>
    </div>

  </div>
</template>

<script>
import ButtonAutoWidth from '../../components/common/button/ButtonAutoWidth'
// 拖拽
import draggable from 'vuedraggable'
export default {
  name: 'check-day-trip-list',
  components: {
    draggable,
    'button-auto': ButtonAutoWidth,
  },
  data() {
    return {
      day_trip: this.dayTrip,
    }
  },
  props: {
    dayTrip: Array,
  },
  computed: {
    // getTakeTaxi(traffic_id) {
    //   this.$http
    //     .get(`/traver/get_traffic_info?traffic_id=${traffic_id}`)
    //     .then((res) => {
    //       console.log(res)
    //       if (res.data.errno == '0') {
    //         return res.data.data.take_taxi
    //       }
    //     })
    // },
  },
  watch: {
    dayTrip(newValue) {
      this.day_trip = newValue
    },
    TrafficPlanList(newVal) {
      this.trafficPlanList = newVal
    },
  },
  methods: {
    // 拖拽
    dragFinish() {
      console.log(this.dayTrip)
    },
    handleCommand() {},

    addTrafficePoint(traver) {
      // 下一个点的 对象 的 poi_id
      let next_traver = this.day_trip[this.day_trip.indexOf(traver) + 1]
      // console.log(next_poi)
      // 显示右侧的添加交通页面
      if (next_traver) {
        this.$emit('openTrafficEditor', traver, next_traver)
      } else {
        this.$message({
          message: '请再添加一个迹点',
          type: 'error',
        })
      }
    },
  },
}
</script>

<style>
.day-trip-item img {
  width: 100%;
}
.day-trip-detail {
  overflow: auto;
}
.day-trip-item {
  border: 1px solid #fdc6b6;
  padding: 10px;
  margin-top: 10px;
}
.traver-point-style-top {
  border: 1px solid #fdc6b6;
  border-bottom-style: none;
  padding: 5px;
}
.traver-point-style {
  border: 1px solid #fdc6b6;
  border-bottom-style: none;
  padding: 5px;
}
.traver-point-style-bottom {
  border: 1px solid #fdc6b6;
  padding: 5px;
}
</style>